// extracted by mini-css-extract-plugin
module.exports = {"section":"_base-section-6141601c78a26999d0d8d97bdf922d6f"};